import { EditingState, SubmittableState, ValidateableState } from "@/app/lib/hooks/use-editor/types/types";

export const defaultValidateableState: ValidateableState = {
    isValid: false,
}

export const defaultSubmittableState: SubmittableState = {
    isSubmitting: false,
    success: null,
}

export const defaultEditableState: EditingState = {
    ...defaultValidateableState,
    ...defaultSubmittableState
}
